export default __webpack_public_path__ + "static/logo-1-745dfac23c68dba7613582ca4362bcae.png";